import loadable from "@loadable/component";
import type { ContentEmbedInterface } from "@ihr-radioedit/inferno-core";
import type { AptivadaAppFragment } from "@ihr-radioedit/inferno-webapi";

const ContentEmbedLegacy = loadable(() => import("./ContentEmbedLegacy.component"));
const AmpContentEmbedLegacy = loadable(() => import("./AmpContentEmbedLegacy.component"));

interface ContestEmbedProps extends AptivadaAppFragment {
  url: string;
  amp?: boolean;
}

export function ContestEmbedLegacy(props: ContestEmbedProps) {
  // Create content embed from contest record fetched from Aptivada
  const { url, amp } = props;
  const display_image = typeof props.displayImage === "string" ? props.displayImage : null;
  const contentProps: ContentEmbedInterface = {
    url,
    image: props.gridImage || display_image || props.primaryImage,
    title: props.title,
    summary: props.subtitle || "",
  };

  return amp ? <AmpContentEmbedLegacy {...contentProps} /> : <ContentEmbedLegacy {...contentProps} />;
}

export default ContestEmbedLegacy;
